import { ref } from 'vue'
export default function useMultiClickToRouterByBiz({ props }) {
  const temps = ref([])

  const vals = props.value?.split(',') ?? []
  const ids = props.id?.split(',') ?? []
  temps.value = vals.map((im, index) => ({
    value: im,
    routerQuery: { id: ids[index] },
  }))

  return { temps }
}
